// api.js – zentrale API-Anbindung.
//
// Vorher war die Basis-URL an fuenf Stellen dupliziert, teils mit
// unterschiedlicher Logik: Profile.js zeigte immer auf die deployte API und
// sprach damit selbst in der lokalen Entwicklung die Produktivdaten an.
import axios from 'axios';
import { globalVars } from './Constants';

const isServerless = process.env.REACT_APP_SERVERLESS === 'true';

export const API_URL = isServerless
  ? globalVars.serverless.apiUrl
  : (process.env.REACT_APP_API_URL || 'http://localhost:4000');

const api = axios.create({ baseURL: API_URL, timeout: 20000 });

// Token automatisch mitschicken – vorher wurde der Authorization-Header an
// jeder Aufrufstelle einzeln (und teils falsch) gesetzt.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/** Fehlermeldung aus einer Axios-Antwort in lesbares Deutsch uebersetzen. */
export function errorMessage(error, fallback = 'Es ist ein Fehler aufgetreten.') {
  const data = error?.response?.data;
  if (!data) {
    return error?.code === 'ECONNABORTED'
      ? 'Zeitueberschreitung. Bitte versuchen Sie es erneut.'
      : fallback;
  }
  if (typeof data === 'string') return data;
  if (data.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors)[0];
    if (first) return first;
  }
  return data.message || data.error || fallback;
}

/** Feldbezogene Validierungsfehler des Servers (Formular-Anzeige). */
export function fieldErrors(error) {
  const errors = error?.response?.data?.errors;
  return errors && typeof errors === 'object' ? errors : {};
}

export default api;
